// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dbefafad","453":"f5d7a4cb","455":"228e2c54"}[chunkId] + ".chunk.js";
};